import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { t } from '../common/Translate';

const SaleStatusTag = ({ status }) => {
  let color;
  let label;
  switch (status) {
    case 'LIVE':
    case 'live':
      color = 'success';
      label = 'liveCoverage';
      break;
    case 'winner_to_designate':
      color = 'secondary';
      label = 'winnerToDesignate';
      break;
    case 'closed_order_confirmed':
      color = 'secondary';
      label = 'coverageCloseOrderConfirmed';
      break;
    case 'closed_no_purchase':
      color = 'secondary';
      label = 'coverageCloseNoPurchase';
      break;
    case 'FINISHED':
    case 'CLOSED':
    case 'ARCHIVED':
      color = 'secondary';
      label = 'closedCoverage';
      break;
    default:
      break;
  }
  return <span className={`badge badge-${color}`}>{label && t(label)}</span>;
};

export default memo(SaleStatusTag);

SaleStatusTag.propTypes = {
  status: PropTypes.string.isRequired,
};
